import { render } from "./index.vue?vue&type=template&id=daa69c86&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=daa69c86&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-daa69c86"

export default script